import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setStep4selectedPackage,
  setStep4selectedPackageFullObject,
} from "../../../../Redux/AddOrEditPartner/AddOrEditPartnerSlice";
import CheckIcon from "../../../../Components/Svgs/packagesIcons/CheckIcon";
import PackageModal from "./PackageModal";
import { Link } from "react-router-dom";
import { USER_TYPES_CATEGORIES } from "../../../../constants/globals";
const Step4PackageCard = ({
  packageDetails,
  packageIcon,
  clientCategory,
  packages,
}) => {
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const dispatch = useDispatch();
  const { lang } = useSelector((state) => state?.UI);
  const { step4 } = useSelector((state) => state?.AddOrEditPartner);
  const { selectedPackage, myWalletBalance } = step4;

  return (
    <div
      className={`tw-px-2 tw-pb-4 d-grid grid-column tw-border tw-rounded-xl text-center o-hidden tw-h-full  ${
        myWalletBalance?.balance >= packageDetails[`total_price`] &&
        packageDetails?.id == selectedPackage
          ? "tw-border-primary tw-shadow-[0px_4px_12px_0px_#10199ECC]"
          : ""
      }`}
    >
      <div className="tw-flex tw-items-center tw-justify-center tw-p-3 tw-relative border-bottom">
        <img
          src={packageIcon}
          alt="PackageCategory"
          className="tw-w-10 tw-inline-block"
        ></img>
        <h4 className="!tw-m-0 tw-text-black tw-px-1">
          {packageDetails[`package_name_${lang}`]}
        </h4>
      </div>
      <>
        <h3 className="tw-text-base tw-text-secondary !tw-my-2">Value</h3>

        <div className="tw-flex tw-items-center tw-flex-col tw-gap-1 tw-text-gray-700">
          {/* original price */}
          {!packageDetails?.price_after_voucher && (
            <div>
              <span className="tw-text-sm tw-text-gray-500 tw-me-2">
                Price:
              </span>
              <span className="tw-text-primary tw-text-lg tw-font-bold">
                {packageDetails.total_price} E.M
              </span>
            </div>
          )}
          {/* After price (if voucher applied) */}
          {packageDetails?.price_after_voucher !== 0 &&
            packageDetails?.price_after_voucher && (
              <>
                {/* Before price */}
                <div className="tw-flex tw-items-center tw-gap-2">
                  <span className="tw-text-sm tw-text-gray-500">
                    Original Price:
                  </span>
                  <span className="tw-line-through tw-text-gray-400">
                    {packageDetails.total_price} E.M
                  </span>
                </div>
                <div className="tw-flex tw-items-center tw-gap-2">
                  <span className="tw-text-sm tw-text-gray-500">
                    After voucher:
                  </span>
                  <span className="tw-text-lg tw-font-bold tw-text-primary">
                    {packageDetails.price_after_voucher} E.M
                  </span>
                </div>
              </>
            )}
          {/* PV points */}
          {USER_TYPES_CATEGORIES.SERVICE_MARKETING === clientCategory && (
            <div className="tw-flex tw-items-center tw-gap-2">
              <span className="tw-text-sm tw-text-gray-500">PV:</span>
              <span className="tw-font-medium">
                {packageDetails.total_package_pv}
              </span>
            </div>
          )}
        </div>

        {/* Courses Included */}
        <h3 className="tw-text-base text-primary !tw-my-2">
          Courses Included ({packageDetails?.courses?.length})
        </h3>
        <div className="!tw-my-2 tw-grid tw-grid-cols-1 !tw-flex-grow lg:tw-grid-cols-2 tw-justify-center lg:tw-text-start tw-gap-y-2 tw-text-sm">
          {packageDetails?.courses?.length > 0 &&
            packageDetails?.courses.map((course, courseIndex) => (
              <p className="tw-px-2" key={courseIndex}>
                <CheckIcon className="tw-w-4 tw-inline-block tw-me-1" />
                <span>{course[`course_name_${lang}`]}</span>
              </p>
            ))}
        </div>
        <div className="tw-mt-auto">
          {myWalletBalance?.balance >= packageDetails[`total_price`] ? (
            <>
              <button
                onClick={() => {
                  if (packageDetails?.id == selectedPackage) return;
                  setIsPackageOpen(true);
                }}
                className={`${
                  packageDetails?.id == selectedPackage
                    ? "tw-bg-primary !tw-cursor-not-allowed hover:!tw-bg-primary"
                    : "tw-bg-[#B0B1B4]"
                } !tw-rounded-lg tw-text-white !tw-px-10 tw-py-1 hover:tw-bg-primaryLight !tw-mt-2`}
              >
                {packageDetails?.id == selectedPackage ? "Selected" : "Select"}
              </button>

              <div className="tw-hidden">
                <input
                  type="radio"
                  className="custom-control-input"
                  value={packageDetails?.id || ""}
                  id={`package-${packageDetails?.id || ""}`}
                  checked={packageDetails?.id == selectedPackage}
                  onChange={(e) => {
                    dispatch(setStep4selectedPackage(e.target.value));
                    let currentPackageIndex = packages.findIndex(
                      (el) => el?.id == e.target.value
                    );
                    dispatch(
                      setStep4selectedPackageFullObject(
                        packages[currentPackageIndex]
                      )
                    );
                  }}
                />
                <label
                  htmlFor={`package-${packageDetails?.id || ""}`}
                  className="custom-control-label"
                ></label>
              </div>
            </>
          ) : (
            <>
              <h3 className="mb-0 fs-6 tw-text-red-500 !tw-mt-2">
                insufficient e-money
              </h3>
              <Link
                to="/partners/request-e-money"
                className="tw-text-[#0b4c8d] tw-underline"
              >
                Get more e-money
              </Link>
            </>
          )}
        </div>
      </>
      <PackageModal
        isOpen={isPackageOpen}
        onClose={() => setIsPackageOpen(false)}
        packageIcon={packageIcon}
        packageDetails={packageDetails}
        setIsPackageOpen={setIsPackageOpen}
        selectedPackage={selectedPackage}
        clientCategory={clientCategory}
      />
    </div>
  );
};

export default Step4PackageCard;
